import type { SiteConfig } from '../../@types/context/site-config.types';
import { insuranceMypageFi } from './insurance-mypage.config';

export const sitePathZmartaFiConfig: Pick<SiteConfig, 'path'> = {
  path: {
    loansApply: '/lainaa-rahaa/yksityislaina/lainahakemus',
    mypage: '/omat-sivut/lainat',
    mypageOverview: '/omat-sivut',
    mypageLoans: '/omat-sivut/lainat',
    creditCard: '/hae/luottokortti',
    insurance: '/hae/matsurvaraus',
    mypageCreditCards: '/omat-sivut/luottokortit',
    oneFormPreflight: '/hae/tunnistautuminen',
    oneFormApply: '/hae/laina',
    oneFormRecommendations: '/hae/kulutusluotto/lisatuotteet',
    ...insuranceMypageFi,
  },
};
